<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <div class="m-b-10">
                <div class="avatar">
                  <!-- <div class="avatar-title rounded-circle fe fe-briefcase"></div> -->
                </div>
              </div>
              <h3 class="h3">Enrollees</h3>

              <div class="form-dark">
                <div class="input-group input-group-flush mb-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SearchUser />

      <div class="container my-4">
        <div class="row">
          <button
            type="button"
            class="btn btn-info mx-2"
            name="button"
            @click="getEnrollees"
          >
            Refresh Enrollees
          </button>

          <button class="btn btn-outline-info mx-2" @click="filterEnrollees">
            Generate Panel List
          </button>

          <button class="btn btn-outline-dark float-right mx-2" v-if="results">
            <download-excel
              :data="results.data"
              :fields="json_fields"
              :header="agency.agency_name"
              type="xls"
              :escapeCsv="false"
              :name="'Enrollee_list.xls'"
            >
              Download {{ results.meta.total }} Enrollee Data
            </download-excel>
          </button>
        </div>
      </div>

      <section class="">
        <div class="container">
          <div class="row list">
            <div class="col-lg-12 col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Phone Number</th>
                          <th>Sector</th>
                          <th>ID</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="client in clients.data"
                          v-bind:key="client.id"
                        >
                          <td>
                            {{ client.full_name }}
                          </td>
                          <td>{{ client.phone_number }}</td>
                          <td>{{ client.sector }}</td>
                          <td>{{ client.id_card_number }}</td>
                          <td>
                            <router-link :to="{ path: '/client/' + client.id }">
                              <button
                                type="button"
                                name="button"
                                class="btn btn-info"
                              >
                                view
                              </button>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="col-lg-4 offset-lg-4">
                      <button
                        class="btn btn-default btn-lg"
                        @click="gotoPrevious"
                      >
                        Previous
                      </button>
                      <button class="btn btn-default btn-lg" @click="gotoNext">
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="vld-parent">
              <loading
                :active.sync="isLoading"
                loader="dots"
                :can-cancel="true"
                :is-full-page="fullPage"
              ></loading>
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
import SearchUser from "@/views/shis/components/SearchUser.vue";
// import FilterUserProvider from '@/views/shis/component/FilterUserProvider.vue'

// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
import moment from "moment";
let agency = JSON.parse(localStorage.getItem("agency"));

moment().format();
export default {
  components: {
    Navbar,
    Loading,
    SearchUser,
  },
  data() {
    return {
      agency: agency,
      isLoading: false,
      fullPage: true,
      orgDetails: "",
      employee: "",
      clients: "",
      state: "",
      results: "",
      json_fields: {
        "Enrollee ID": "id_card_number",
        "User Type": "account_type",
        Relation: "relation",
        "First Name": "firstname",
        "Last Name": "lastname",
        "Middle Name": "middlename",
        Gender: "gender",
        "User Image": {
          field: "user_image",
          callback: (value) => {
            return `https://claimify-api.hayokmedicare.ng/image/${value}`;
          },
        },

        "Date of Birth": "dob",
        "Phone Number": "phone_number",
        "Health Provider": "userprovider.agency_name",
        "Provider Code": "userprovider.facility_code",
        Establishment: "place_of_work",

        Program: "sector",
        HMO: "usertpa.organization_name",
        // Principal: "user.full_name",
        "Vulnerable Group": "category_of_vulnerable_group",
        "Date Enrolled": "created_at",
        NIN: "nimc_number",
      },
      current_page: 1,
      form: {
        selected_agency: "",
        gender: "",
        dependents: true,
        category_of_vulnerable_group: "",
        hmos: [],
        establishments: [],
        sectors: [],
        ward: "",
        localgovt: "",
        place_of_work: "",
        provider_id: "",
        org_id: "",
        from: "",
        to: "",
        dob_operator: "",
        dob: "",
        dep_operator: "",
        dep_dob: "",
        dep_gender: "",
        per_page: 100000,
        current_page: 1,
        order_by: "provider_id",
      },
    };
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  methods: {
    gotoNext() {
      if (this.clients.meta.current_page != this.clients.meta.last_page) {
        this.current_page++;
        this.getEnrollees();
      } else {
        this.$toasted.info("You have reached the Last Page", {
          position: "top-center",
          duration: 3000,
        });
      }
    },
    gotoPrevious() {
      if (this.clients.meta.current_page != 1) {
        this.current_page--;
        this.getEnrollees();
      } else {
        this.$toasted.info("You have reached the First Page", {
          position: "top-center",
          duration: 3000,
        });
      }
    },
    getUSerDetails() {
      this.user = JSON.parse(localStorage.getItem("user"));

      this.getEnrollees();
    },

    getEnrollees() {
      this.isLoading = true;
      this.user = JSON.parse(localStorage.getItem("user"));

      // get clients
      this.axios
        .get(`/api/v1/auth/org_client/${this.user.institutional_id}`, {
          params: {
            page: this.current_page,
          },
        })
        .then((response) => {
          this.clients = response.data;
          this.isLoading = false;

          console.log(response);
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },

    filterEnrollees() {
      this.isLoading = true;
      this.axios
        .post(`/api/v1/auth/filtersectordashboardwardlgabydate`, {
          agency_id: agency.id,
          sectors: this.form.sectors,
          establishments: this.form.establishments,
          gender: this.form.gender,
          from: this.form.from,
          to: this.form.to,
          dependents: this.form.dependents,
          provider_id: this.form.provider_id,
          place_of_work: this.form.place_of_work,
          org_id: this.user.institutional_id,
          per_page: 100000,
          page: this.form.current_page,
          order_by: this.form.order_by,
        })
        .then((response) => {
          this.results = response.data;
          console.log(response);
          this.isLoading = false;
          this.$toasted.success("Panel List Generated Successfully", {
            position: "top-center",
            duration: 3000,
          });
        })
        .catch((error) => {
          this.isLoading = false;
          this.$toasted.error("Error!", {
            position: "top-center",
            duration: 3000,
          });

          console.error(error);
        });
    },
  },
  created() {
    this.getEnrollees();
  },
};
</script>
